/*
 *   File : statistics.js
 *   Author : https://evoqins.com
 *   Description : Statistics card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

const StatisticCard = (props) => {
    return (

        <div className={`e-bg-lavender-light border-radius-12 p-3 d-flex flex-column h-100 gap-12px justify-content-between `}>
            <p className='mb-0 e-text-davys-grey e-primary-font e-font-14 e-font-weight-400 line-height-16px '>
                {props.title}
            </p>
            <p className={`${props.color ? props.color : "e-text-smoky-black"} mb-0  e-primary-font e-font-16 e-font-weight-600 line-height-18px`}>
                {props.value}
            </p>
        </div>

    )
}

export default StatisticCard;
